import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styles from "./Chat1.module.css";
import chat1Av from "../assets/direct/chat1.png";
import ChatHeader from "../components/ChatComponents/ChatHeader";
import ChatBody from "../components/ChatComponents/ChatBody";
import ChatInput from "../components/ChatComponents/ChatInput";
import ChatMessageTime from "../components/ChatComponents/ChatMessageTime";
import ChatMessageOther from "../components/ChatComponents/ChatMessageOther";
import ChatMessageMe from "../components/ChatComponents/ChatMessageMe";
import ChatMessageImage from "../components/ChatComponents/ChatMessageImage";
import ChatAudioOther from "../components/ChatComponents/ChatAudioOther";
import OldMessage from "../components/ChatComponents/OldMessage";
import nudeImage from "../assets/chat/nudes1-chat1.jpg";

export default function Chat1() {
  const { t } = useTranslation();
  const [city, setCity] = useState("casa");
  useEffect(() => {
    async function fetchLocation() {
      try {
        const res = await fetch("https://wtfismyip.com/json");
        if (!res.ok) return;

        const data = await res.json();

        if (data?.YourFuckingLocation) {
          const parts = data.YourFuckingLocation.split(",");
          setCity((parts[0] || "casa").trim());
        }
      } catch {}
    }

    fetchLocation();
  }, []);

  return (
    <div className={styles.chatPageChat1}>
      <ChatHeader username="Jo*****" avatar={chat1Av} status={t('chat.online')} />
      <ChatBody>
        {/* ===== MENSAGENS MUITO ANTIGAS (BLUR FORTE) ===== */}
        <OldMessage>
          <ChatMessageTime time="1 SEMANA ATRÁS" />
          <ChatMessageOther text="Oi amor" />
          <ChatMessageMe text="Oi bb" />
          <ChatMessageOther text="Saudades" showAvatar={false} />
          <ChatMessageMe text="Tbm ❤️" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="6 DIAS ATRÁS" />
          <ChatMessageOther text="Bom dia 😘" />
          <ChatMessageMe text="Bom dia amor" />
          <ChatMessageOther text="Que horas sai?" showAvatar={false} />
          <ChatMessageMe text="Umas 18h" />
          <ChatMessageOther text="Blz" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="5 DIAS ATRÁS" />
          <ChatMessageOther text="Oi delícia" />
          <ChatMessageMe text="Oii" />
          <ChatMessageMe text="To com sdd" />
          <ChatMessageOther text="Eu também amor" showAvatar={false} />
          <ChatMessageOther text="Vem me ver?" showAvatar={false} />
          <ChatMessageMe text="Vou sim" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="4 DIAS ATRÁS" />
          <ChatMessageOther text="E aí?" />
          <ChatMessageMe text="Fala" />
          <ChatMessageOther text="Nada, você sumiu" showAvatar={false} />
          <ChatMessageMe text="Desculpa, tava ocupado" />
          <ChatMessageOther text="Tá bom" showAvatar={false} reaction="😔" />
        </OldMessage>

        {/* ===== CONVERSA PRINCIPAL ===== */}
        <ChatMessageTime time={`${t('chats.time.3daysAgo')}, 11:12`} />

        <ChatMessageOther text={t('chats.chat1.hiGorgeous')} />
        <ChatMessageMe text={t('chats.chat1.hiLoveOfLife')} />
        <ChatMessageMe text={t('chats.chat1.lifeTypo')} />
        <ChatMessageOther text={t('chats.chat1.missYou')} showAvatar={false} />

        <ChatMessageImage
          imageSrc={nudeImage}
          reaction="❤️"
          showAvatar={false}
        />

        <ChatMessageOther text={t('chats.chat1.thisQ')} showAvatar={false} />
        <ChatMessageMe text="😍😍😍😍😍😍" />
        <ChatMessageOther text={t('chats.chat1.didYouLike')} showAvatar={false} />

        {/* ÁUDIO BLOQUEADO */}
        <ChatAudioOther duration="0:11" showAvatar={false} />

        <ChatMessageOther
          text={t('chats.chat1.cityMsg1', { city })}
          showAvatar={false}
        />

        <ChatMessageMe text={t('chats.chat1.tomorrowOrAfter')} reaction="👍🏻" />

        <ChatMessageTime time={`${t('direct.yesterday')}, 21:34`} />

        <ChatMessageOther text={t('chats.chat1.babe')} />
        <ChatMessageOther text={t('chats.chat1.canTalk')} showAvatar={false} />

        <ChatMessageMe
          text={t('chats.chat1.heyBb')}
          replyTo={{
            label: t('chat.youReplied'),
            text: t('chats.chat1.babe')
          }}
        />

        <ChatMessageOther
          text={t('chats.chat1.bruninhaMsg')}
          blurWords={[t('chats.chat1.bruninhaBlur')]}
          showAvatar={false}
        />

        <ChatMessageMe text={t('chats.chat1.lmao')} />
        <ChatMessageOther text={t('chats.chat1.deer')} reaction="😂" showAvatar={false} />

        <ChatMessageOther
          text={t('chats.chat1.cityMsg2', { city })}
          showAvatar={false}
          reaction="❤️"
        />

        <ChatMessageMe text={t('chats.chat1.whereStay')} />
        <ChatMessageMe text={t('chats.chat1.atCousin')} />

        <ChatMessageOther
          text={t('chats.chat1.notAtCousin')}
          replyTo={{
            label: t('chat.repliedToYou'),
            text: t('chats.chat1.atCousin')
          }}
        />

        <ChatMessageOther text={t('chats.chat1.stayingThere')} showAvatar={false} />
        <ChatMessageMe text={t('chats.chat1.okEmoji')} />
        <ChatMessageMe text={t('chats.chat1.passByQ')} reaction="❤️" />

        <ChatMessageTime time={`${t('direct.today')}, 15:22`} />

        {/* ÁUDIOS BLOQUEADOS */}
        <ChatAudioOther duration="0:32" />
        <ChatAudioOther duration="0:07" showAvatar={false} />

        <ChatMessageMe text={t('chats.chat1.canDo')} />
        <ChatMessageOther text={t('chats.chat1.heart')} showAvatar={false} />

        <ChatMessageTime time="16:53" />

        <ChatMessageOther text={t('chats.chat1.guessWhat')} />
      </ChatBody>

      <ChatInput />
    </div>
  );
}